export const locale = {
    lang: 'en',
    multiselect_pools: {
        POOLS_TITLE: 'ASSIGN TO COLLECTION POOLS',
    }
};
